/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Guidevideo_Duration_Read1Inputs */

const vi_guidevideo_duration_read1 = /** @type {(inputs: Guidevideo_Duration_Read1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thời lượng: ${i?.duration}`)
};

/**

* @param {Guidevideo_Duration_Read1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_duration_read1 = /** @type {((inputs: Guidevideo_Duration_Read1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Duration_Read1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_duration_read1(inputs)
});
export { guidevideo_duration_read1 as "guideVideo_duration_read" }